import { render, staticRenderFns } from "./workOrderHeaderInfo.vue?vue&type=template&id=ddaa0b5e&scoped=true&"
import script from "./workOrderHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./workOrderHeaderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa0b5e",
  null
  
)

export default component.exports